const map: Record<string, string> = {
  pix: "PIX",
  credit: "Cartão de Crédito",
  debit: "Cartão de Débito",
  money: "Dinheiro",
}

export function paymentTypeLabel(paymentType?: string | null): string | null {
  if (!paymentType) return null
  return map[paymentType] ?? null
}
